/**
 * We recommend not adding a custom type for this object, and instead letting
 * TypeScript infer the type automatically.
 *
 * However, if you do find that adding an explicit type is necessary in a given
 * app, consider using this approach to ensure that things like autocompletion
 * and nonexistent property checks continue to work properly:
 * https://github.internal.digitalocean.com/digitalocean/cra-template-do/pull/31/files
 *
 * For easier maintainability, we also recommend keeping the structure of this
 * object relatively flat -- ideally no more than 2-3 levels deep.
 */
const copy = {
  indexTitle: 'App Index',
  detailTitle: 'App Detail',
  pageTitles: {
    defaultTitle: 'DigitalOcean',
    titleTemplate: '%s - DigitalOcean'
  }
};

export default copy;
